export default [{
        path: '/students',
        name: 'students',
        component: () =>
            import ('@/views/pages/students/students-list/StudentsList.vue'),
        meta: {
            pageTitle: 'Students',
            breadcrumb: [{
                text: 'Students',
                active: true,
                to: '/students',
            }, ],
            resource: 'student',
            action: 'read',
        },
    },
    {
        path: '/students/view/:id',
        name: 'students-view',
        component: () =>
            import ('@/views/pages/students/students-view/StudentsView.vue'),
        meta: {
            pageTitle: 'View Student',
            breadcrumb: [
            {
                text: 'Students',
                to: '/students',
            },{
                text: 'View',
                active: true,
            } ],
            resource: 'student',
            action: 'read',
        },
    },
    {
        path: '/students/edit/:id',
        name: 'students-edit',
        component: () =>
            import ('@/views/pages/students/students-edit/StudentsEdit.vue'),
        meta: {
            pageTitle: 'Edit Student',
            breadcrumb: [
            {
                text: 'Students',
                to:'/students',
            },
            {
                text: 'Edit',
                active: true,
            } ],
            resource: 'student',
            action: 'read',
        },
    },
    {
        path: '/students/add',
        name: 'students-add',
        component: () =>
            import ('@/views/pages/students/students-add/StudentsAdd.vue'),
        meta: {
            pageTitle: 'Add Student',
            breadcrumb: [
            {
                text: 'Students',
                to:'/students',
            },
            {
                text: 'Add',
                active: true,
            } ],
            resource: 'student',
            action: 'read',
        },
    },
]